import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit'
import { UIReducer as UI } from './slices/UI'
import { EventReducer as Event } from './slices/Event'
import { OrganizerReducer as Organizer } from './slices/Organizer'
import { QuizReducer as Quiz } from './slices/Quiz'

export const rootReducer = combineReducers({
  UI,
  Event,
  Organizer,
  Quiz,
})

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
